import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ClaimserviceService } from "../service/claimservice.service";
import { AllLinksComponent } from "src/app/core/all-links/all-links.component";
import { LearnerService } from "src/app/core/services/learner.service";
import { LoginService } from "src/app/core/login/login.service";
import { DatePipe } from "@angular/common";
import { SidebarService } from 'src/app/core/services/sidebar.service';
import * as $ from "jquery";
@Component({
  selector: "app-all-claim",
  templateUrl: "./all-claim.component.html",
  styleUrls: ["./all-claim.component.scss"],
})
export class AllClaimComponent implements OnInit {
  tableData: any[] = [];
  currentPage: number = 1;
  totalPages: number = 0;
  pageSize: number = 10;
  totalCount: number = 0;
  // User related
  isAdmin: boolean = false;
  user: any;
  name: any;
  lndUserType: boolean = false;
  sidebarCollapsed: boolean = false;

  // Filters
  uname: string = "";
  uemail: string = "";
  claimid: any = "";
  pcode: any = "";
  legalentity: string = "";
  status: string = "";
  approvedDate: Date | "" = "";
  external: boolean = false;
  filter_value: boolean = false;

  // Others
  @ViewChild("externalCheckbox", { static: true }) externalCheckbox: ElementRef;
  numButtons: number = 10;
  start: number;
  end: number;
  middle: number;
  ledata: any;
  link: any;
  documents: any;
  user_type: any;
  headingOne: string = "List Of Claims";
  searchQuery: string = '';
  items: any = [];
  filteredItems: any;
  date_length: any;
  userdata: any = [];
  metadata: any;
  fromdate: any;
  todate: any;

  constructor(
    private route: ActivatedRoute,
    private claimservice: ClaimserviceService,
    private router: Router,
    public allLink: AllLinksComponent,
    private learnerService: LearnerService,
    private loginService: LoginService,
    private datePipe: DatePipe,
    private sidebarService: SidebarService
  ) {}


  externalValue(isChecked: boolean) {
    if (isChecked) {
      this.external = true;
    } else {
      this.external = false;
    }
  }
  // Format Date into dd-MM-yyyy
  private formatDate(date: Date | ""): string {
    return date ? this.datePipe.transform(date, "dd-MM-yyyy") || "" : "";
  }

  // Parse dd-MM-yyyy → Date
  private parseDate(dateStr: string | ""): Date | "" {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("-");
    return new Date(+year, +month - 1, +day);
  }

  ngOnInit() {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });

    //  Get user type
    this.learnerService.getUserType().subscribe(
      (res) => {
        this.user = res["lnd_user_type"];
        this.lndUserType = true;
        localStorage.setItem("user_type", res["lnd_user_type"]);
        this.isAdmin = res["lnd_user_type"] === "admin";
      },
      (error: any) => {
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );

    this.name = localStorage.getItem("name");

    //  Restore filters from query params
    this.route.queryParams.subscribe((params) => {
      this.currentPage = +params["page"] || 1;
      this.uname = params["submitter_name"] || "";
      this.uemail = params["submitter_email"] || "";
      this.claimid = params["claim_id"] || "";
      this.pcode = params["project_code"] || "";
      this.legalentity = params["legal_entity"] || "";
      this.status = params["status"] || "";
      this.approvedDate = this.parseDate(params["last_approved_date"] || "");
      this.external = params["external"] === "true";

      this.filter_value =
        !!(
          this.uname ||
          this.uemail ||
          this.claimid ||
          this.pcode ||
          this.legalentity ||
          this.approvedDate ||
          this.external
        );
    });

     this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
  }

  // Header functionality methods
  onSearchInput(searchTerm: string): void {
    this.searchQuery = searchTerm;
    // Store search query (don't open dialog on input)
  }

  addClaim(): void {
    // Navigate to add claim page or open dialog
    this.router.navigate(['/expense-manager/add-claim']);
  }

  exportClaims(): void {
    // Implement export functionality
    console.log('Exporting claims...');
    // Example: generate Excel/CSV export
  }

  openFilterDialog(): void {
    // Trigger the existing filter button click to open modal
    const filterBtn = document.querySelector('[data-bs-target="#exampleModal"]') as HTMLElement;
    if (filterBtn) {
      filterBtn.click();
    }
  }

  //  Apply filters
  _filterData() {
    this.currentPage = 1;

    this.filter_value =
      !!(
        this.uname ||
        this.uemail ||
        this.claimid ||
        this.pcode ||
        this.legalentity ||
        this.approvedDate ||
        this.external
      );

    if (this.filter_value) {
      this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
    } else {
      this.clearFilter();
    }
  }

  fetchData(
    page: number,
    uname: any,
    uemail: any,
    claimid: any,
    pcode: any,
    legalentity: any,
    status: string,
    approvedDate: any,
    external: boolean
  ) {
    this.claimservice
      .allClaim(
        page,
        uname,
        uemail,
        claimid,
        pcode,
        legalentity,
        status,
        approvedDate,
        external
      )
      .subscribe(
        (data: any) => {
          this.tableData = data.data;
          this.ledata = data.meta.legal_entity;
          this.totalCount = data.meta.count;
          this.totalPages = Math.ceil(this.totalCount / this.pageSize);

          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              page: this.currentPage,
              submitter_name: this.uname,
              submitter_email: this.uemail,
              claim_id: this.claimid,
              project_code: this.pcode,
              legal_entity: this.legalentity,
              status: this.status,
              last_approved_date: this.formatDate(this.approvedDate),
              external: this.external ? "true" : "false",
            },
            
            replaceUrl: true,
          });

          if (data.status) {
            $(".allclaimPopup").click();
          }
        },
        (error) => {
          console.error("Error fetching data:", error);
        }
      );
  }

  // Table Row Click
  onTableIdClick(id: any) {
    this.link = `/detailclaim/${id}`;
    window.open(this.link, "_blank");
  }

  //  Pagination
  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
    }
  }

  firstPage() {
    this.currentPage = 1;
    this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
  }

  lastPage() {
    this.currentPage = this.totalPages;
    this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
  }

  gotoPage(page: number) {
    this.currentPage = page;
    this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
  }

  getNumericButtons(): number[] {
    this.numButtons = 10;
    this.middle = Math.ceil(this.numButtons / 2);
    this.start = Math.max(1, this.currentPage - this.middle + 1);
    this.end = Math.min(this.totalPages, this.start + this.numButtons - 1);

    const buttons: number[] = [];
    for (let i = this.start; i <= this.end; i++) {
      buttons.push(i);
    }
    return buttons;
  }

  //  Radio Change
  onRadioChange(selectedStatus: string) {
    this.currentPage = 1;
    this.status = selectedStatus;
    this.fetchData(
        this.currentPage,
        this.uname,
        this.uemail,
        this.claimid,
        this.pcode,
        this.legalentity,
        this.status,
        this.formatDate(this.approvedDate),
        this.external
      );
  }

  //  Clear Filters
  clearFilter() {
    this.currentPage = 1;
    this.uname = "";
    this.uemail = "";
    this.claimid = "";
    this.pcode = "";
    this.legalentity = "";
    this.approvedDate = "";
    this.status = "";
    this.external = false;
    this.externalCheckbox.nativeElement.checked = false;
    this.filter_value = false;

    this.fetchData(
      this.currentPage,
      this.uname,
      this.uemail,
      this.claimid,
      this.pcode,
      this.legalentity,
      this.status,
      "",
      this.external
    );
  }

  _clearData() {
    this.uname = "";
    this.uemail = "";
    this.pcode = "";
    this.claimid = "";
    this.legalentity = "";
    this.approvedDate = "";
    if (this.externalCheckbox.nativeElement.checked) {
      this.external = false;
      this.externalCheckbox.nativeElement.checked = false;
    }
  }

}
